// AI-CONTEXT: See docs/patterns.md#hook-permission-gate
//
// Per-area permission keys. Each gated area exposes a `.view` key (controls
// whether the area is reachable at all) and a `.edit` key (controls whether
// its content can be changed). A view-only role holds every `.view` key and
// no `.edit` keys. Special keys (team.invite/delete, data.export, roles.manage,
// forms.bulkentry) gate single actions.

const permissionsCatalog = [
    // --- Team & rollen ---
    {
        key: 'team.view',
        label: 'Team bekijken',
        description: 'Bekijk teamleden en hun gegevens.',
        category: 'Team & rollen',
    },
    {
        key: 'team.edit',
        label: 'Teamleden bewerken',
        description: 'Pas gegevens van teamleden aan.',
        category: 'Team & rollen',
    },
    {
        key: 'team.invite',
        label: 'Teamleden uitnodigen',
        description: 'Nodig nieuwe leden uit voor het team.',
        category: 'Team & rollen',
    },
    {
        key: 'team.delete',
        label: 'Teamleden verwijderen',
        description: 'Verwijder leden uit het team.',
        category: 'Team & rollen',
    },
    {
        key: 'roles.manage',
        label: 'Rollen beheren',
        description: 'Maak rollen aan, pas rechten aan en verwijder rollen.',
        category: 'Team & rollen',
    },

    // --- Instellingen & data ---
    {
        key: 'settings.view',
        label: 'Instellingen bekijken',
        description: 'Bekijk de algemene instellingen.',
        category: 'Instellingen & data',
    },
    {
        key: 'settings.edit',
        label: 'Instellingen aanpassen',
        description: 'Pas algemene instellingen aan.',
        category: 'Instellingen & data',
    },
    {
        key: 'data.view',
        label: 'Data bekijken',
        description: 'Bekijk de data-instellingen en standaardvelden.',
        category: 'Instellingen & data',
    },
    {
        key: 'data.edit',
        label: 'Data bewerken',
        description: 'Pas data-instellingen en standaardvelden aan.',
        category: 'Instellingen & data',
    },
    {
        key: 'data.export',
        label: 'Data exporteren',
        description: 'Exporteer gegevens uit het systeem.',
        category: 'Instellingen & data',
    },

    // --- Impactstrategie ---
    {
        key: 'strategy.view',
        label: 'Impactstrategie bekijken',
        description: 'Bekijk activiteiten, effecten en doelen.',
        category: 'Impactstrategie',
    },
    {
        key: 'strategy.edit',
        label: 'Impactstrategie bewerken',
        description: 'Pas activiteiten, effecten en doelen aan.',
        category: 'Impactstrategie',
    },
    {
        key: 'measurement.view',
        label: 'Meetplan bekijken',
        description: 'Bekijk het meetplan.',
        category: 'Impactstrategie',
    },
    {
        key: 'measurement.edit',
        label: 'Meetplan bewerken',
        description: 'Pas het meetplan aan.',
        category: 'Impactstrategie',
    },

    // --- Ondersteuning ---
    {
        key: 'personas.view',
        label: 'Personas bekijken',
        description: 'Bekijk personas en hun gegevens.',
        category: 'Ondersteuning',
    },
    {
        key: 'personas.edit',
        label: 'Personas bewerken',
        description: 'Pas personas en hun gegevens aan.',
        category: 'Ondersteuning',
    },
    {
        key: 'housevisits.view',
        label: 'Huishoudens bekijken',
        description: 'Bekijk huishoudens en huisbezoeken.',
        category: 'Ondersteuning',
    },
    {
        key: 'housevisits.edit',
        label: 'Huishoudens bewerken',
        description: 'Pas huishoudens en huisbezoeken aan.',
        category: 'Ondersteuning',
    },
    {
        key: 'addresses.view',
        label: 'Adressen bekijken',
        description: 'Bekijk adressen en hun gegevens.',
        category: 'Ondersteuning',
    },
    {
        key: 'addresses.edit',
        label: 'Adressen bewerken',
        description: 'Pas adressen en hun gegevens aan.',
        category: 'Ondersteuning',
    },
    {
        key: 'forms.view',
        label: 'Formulieren bekijken',
        description: 'Bekijk intakeformulieren en reacties.',
        category: 'Ondersteuning',
    },
    {
        key: 'forms.edit',
        label: 'Formulieren bewerken',
        description: 'Maak en pas intakeformulieren aan.',
        category: 'Ondersteuning',
    },
    {
        key: 'forms.bulkentry',
        label: 'Bulk invoer intakeformulieren',
        description: 'Vul intakeformulieren in bulk in — na verzenden blijft het formulier open om opnieuw in te vullen.',
        category: 'Ondersteuning',
    },
    {
        key: 'billing.view',
        label: 'Facturatie bekijken',
        description: 'Bekijk tarieven per deelnemer, de rekenregels en de facturatie per maand.',
        category: 'Ondersteuning',
    },
    {
        key: 'billing.edit',
        label: 'Facturatie bewerken',
        description: 'Pas tarieven per deelnemer en de rekenregels aan, en voeg extra regels toe aan de facturatie.',
        category: 'Ondersteuning',
    },

    // --- Planning ---
    {
        key: 'calendar.view',
        label: 'Agenda bekijken',
        description: 'Bekijk de agenda en afspraken.',
        category: 'Planning',
    },
    {
        key: 'calendar.edit',
        label: 'Agenda bewerken',
        description: 'Maak en pas afspraken aan.',
        category: 'Planning',
    },
    {
        key: 'tasks.view',
        label: 'Taken bekijken',
        description: 'Bekijk taken.',
        category: 'Planning',
    },
    {
        key: 'tasks.edit',
        label: 'Taken bewerken',
        description: 'Maak en pas taken aan.',
        category: 'Planning',
    },

    // --- Rapportages ---
    {
        key: 'reports.view',
        label: 'Rapportages bekijken',
        description: 'Bekijk live-rapportages.',
        category: 'Rapportages',
    },
    {
        key: 'reports.edit',
        label: 'Rapportages bewerken',
        description: 'Maak en pas live-rapportages aan.',
        category: 'Rapportages',
    },

    // --- Portfolio ---
    {
        key: 'portfolio.view',
        label: 'Portfolio bekijken',
        description: 'Bekijk het portfolio.',
        category: 'Portfolio',
    },
    {
        key: 'portfolio.edit',
        label: 'Portfolio bewerken',
        description: 'Pas het portfolio aan.',
        category: 'Portfolio',
    },
]

export default permissionsCatalog
